import { App } from './App';
import { ChakraProvider } from '@chakra-ui/react';
import { chakraTheme } from './theme/theme';
import { WagmiProvider } from 'wagmi';
import { config } from './config';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ReactDOM from 'react-dom/client';
import { ConnectWalletProvider } from './context/ConnectWalletProvider';
import { LoaderProvider } from "./context/GlobalLoader";

const queryClient = new QueryClient();
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <ChakraProvider theme={chakraTheme}>
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <ConnectWalletProvider>
          <LoaderProvider>
            <App />
          </LoaderProvider>
        </ConnectWalletProvider>
      </QueryClientProvider>
    </WagmiProvider>
  </ChakraProvider>,
);
